enum ParityPriceComparisonAlertRuleDifferenceType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT'
}

export default ParityPriceComparisonAlertRuleDifferenceType;